<div class="select-container">
  <app-export-button
    (export)="exportAll()"
    [exportLoading]="exportLoading()"
    size="sm"
    width="170px"
  />
  <app-radar-chart
    [data]="data"
    [chartTitle]="dictionaryService.get('AverageScores')"
    [height]="320"
    [width]="420"
    [isLoading]="isLoading()"
  />
  <app-select
    [options]="teamMembers"
    [name]="dictionaryService.get('SelectedUsers')"
    type="check"
    (getCheckedItems)="changeSelectedUsers($event)"
  ></app-select>
</div>
<app-tabs> <app-evaluations-tab></app-evaluations-tab> </app-tabs>`
